<template>
    <v-card class="modal--tips4y">
        <v-card-title>
            <slot name="title">
                <span>{{ title }}</span>
            </slot>
        </v-card-title>

        <v-card-text>
            <slot name="body" :message="message">
                <span>{{ message }}</span>
            </slot>
        </v-card-text>

        <v-card-actions class="align__flex--center">
            <v-btn class="primary-button" color="primary" text @click="$emit('ok-clicked')"> {{$t('ok')}} </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        message: {
            type: String,
            required: true
        }
    }
};
</script>
